
export const WINDOWS_CURSOR_STEPS = [
    0.03125, 0.0625, 0.125, 0.25, 0.375, 0.5, 0.625, 0.75, 0.875, 1, 1.25, 1.5,
    1.75, 2, 2.25, 2.5, 2.75, 3, 3.25, 3.5,
];

export const calculateOptimalWindowsCursorDpi = ({ originalCursorEdpi, targetSens, idealGameEdpi }: { originalCursorEdpi: number, targetSens: number, idealGameEdpi: number }) => {


    const steps = WINDOWS_CURSOR_STEPS.map((step, i) => {
        const newDpi = Math.round(originalCursorEdpi / step); // Targeting the original cursor eDPI, not the ideal DPI
        const newGameEdpi = newDpi * targetSens;

        return {
            windowsCursorStep: i + 1,
            multiplier: step,
            dpi: newDpi,
            game: {
                edpi: newGameEdpi,
                targetEdpi: idealGameEdpi,
                errorPct: (Math.abs(idealGameEdpi - newGameEdpi) / idealGameEdpi) * 100,
            }
        }
    });
    return steps.sort((a, b) => a.game.errorPct - b.game.errorPct)[0]!;
}

const calculateClosestWindowsCursorDpi = ({ targetCursorEdpi, selectedDpi }: { targetCursorEdpi: number, selectedDpi: number }) => {
    const steps = WINDOWS_CURSOR_STEPS.map((step, i) => {
        const edpi = selectedDpi * step;
        return {
            targetCursorEdpi,
            windowsCursorStep: i + 1,
            multiplier: step,
            cursorEdpi: edpi,
            errorPct: (Math.abs(targetCursorEdpi - edpi) / targetCursorEdpi) * 100,
        }
    });

    return steps.sort((a, b) => a.errorPct - b.errorPct)[0]!;
}


export const calculateOptimalGameDpi = ({ originalEdpi, originalCursorEdpi, targetSens }: { originalEdpi: number, originalCursorEdpi: number, targetSens: number }) => {
    const idealDpi = originalEdpi / targetSens;
    const dpi = Math.round(idealDpi);
    const edpi = targetSens * dpi;
    const errorPct = (Math.abs(originalEdpi - edpi) / originalEdpi) * 100;

    const closestWindowsCursor = calculateClosestWindowsCursorDpi(
        {
            selectedDpi: dpi,
            targetCursorEdpi: originalCursorEdpi,
        }
    );

    return {
        dpi,
        targetEdpi: originalEdpi,
        edpi,
        edpiErrorPct: errorPct,
        windowsCursor: closestWindowsCursor
    }
}
